import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import EditModel from './models/editModel'
import User from '@/domain/user'

export default mixins(routeMixin).extend({
    data() {
        return {
            isModifiable: false
        }
    },
    methods: {
        back() {
            this.navigateToHome()
        },
        editProfile() {
            this.$http
                .api('account')
                .put(
                    new EditModel({
                        userName: this.$database.account.email,
                        prenom: this.$database.account.prenom,
                        nom: this.$database.account.nom,
                        email: this.$database.account.email
                    })
                )
                .then(() => {
                    this.$database.save()
                    this.$swal.toast.success()
                    this.isModifiable = false
                })
                .catch(() => {
                    this.$database.reload()
                    this.$swal.toast.error('Certains champs ne remplissent pas les règles de saisie.')
                })
        },
        logout() {
            this.$auth.logout()
            this.$database.clear()
            this.$database.save()
            this.$database.account = new User()
            this.navigateToHome()
        }
    }
})
